// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentLoader_wrapper__EDVPk"};